module.exports = __webpack_public_path__ + "img/p_point.2bb55f08.png";